export enum BillingType {
  Billable = 0,
  Training = 6,
  NonBillable = 99,
}
